"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
var defaultSettings_1 = require("../../../shared/internal/Context/defaultSettings");
var utils_1 = require("../../../shared/internal/utils");
var TELEMETRY_ENABLED_SETTING_KEY = 'http.browser.telemetry.enabled';
var Context = /** @class */ (function () {
    function Context(params) {
        this.config = params.config;
        this.requestConfig = params.requestConfig;
        this.userConfig = params.userConfig || {};
        this.requestHash = params.requestHash;
        this.model = params.model;
        this.globalAssertStatusCode = params.assertStatusCode;
        this.requestedServerName = params.requestedServerName;
        this.cancellationToken = params.cancellationToken;
    }
    Object.defineProperty(Context.prototype, "failureTreshold", {
        get: function () {
            var failureTreshold = this.config.get('http.browser.circuitBreaker.failureTreshold') || 0.9;
            return failureTreshold;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "minimumSamples", {
        get: function () {
            var minimumSamples = this.config.get("http.browser.circuitBreaker.minimumSamples") || 9;
            return minimumSamples;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "maximumSamples", {
        get: function () {
            var maximumSamples = this.config.get("http.browser.circuitBreaker.maximumSamples") || 10;
            return maximumSamples;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "maxTimeForHalfOpenRequest", {
        get: function () {
            var maxTimeForHalfOpenRequest = this.config.get("http.browser.circuitBreaker.maxTimeForHalfOpenRequest") || 5000;
            return maxTimeForHalfOpenRequest;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "openDuration", {
        get: function () {
            var openDuration = this.config.get("http.browser.circuitBreaker.openDuration") || 5000;
            return openDuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "samplingDuration", {
        get: function () {
            var samplingDuration = this.config.get("http.browser.circuitBreaker.samplingDuration") || 5000;
            return samplingDuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "timeout", {
        get: function () {
            var timeout = this.userConfig.timeout || this.config.get("http.browser.timeout") || 10000;
            return timeout;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "assertStatusCode", {
        get: function () {
            if (this.userConfig.assertStatusCode) {
                return this.userConfig.assertStatusCode;
            }
            if (this.model) {
                var forceGlobal = this.config.get('http.browser.assertStatusCode.forceGlobal');
                /**
                 * Это необходимо для обратной совместимости, если настройки в RS нет, то в старых мажорах
                 * приортет всегда отдавался глобальному ассерту.
                 */
                return forceGlobal === null || forceGlobal
                    ? this.globalAssertStatusCode || (0, defaultSettings_1.defaultModelAssertStatusCode)(this.model.assertStatusCodes)
                    : (0, defaultSettings_1.defaultModelAssertStatusCode)(this.model.assertStatusCodes);
            }
            return this.globalAssertStatusCode || defaultSettings_1.defaultAssertStatusCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "telemetryEnabled", {
        get: function () {
            var config = this.config;
            if (config.has(TELEMETRY_ENABLED_SETTING_KEY)) {
                return config.getStrict(TELEMETRY_ENABLED_SETTING_KEY);
            }
            return config.get('mcsRunEnv') === 'local';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "requestType", {
        get: function () {
            var requestType = this.config.get('http-api.browser.requestType');
            if (requestType === 'fetch' && window.fetch && window.AbortController) {
                return 'fetch';
            }
            return 'xhr';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "simplifiedPath", {
        get: function () {
            return (0, utils_1.simplifyPath)(this.requestConfig.url.pathname, this.config);
        },
        enumerable: false,
        configurable: true
    });
    return Context;
}());
exports.Context = Context;
//# sourceMappingURL=Context.js.map